import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function ProductBenefits({ product, productName }) {
  // Animation variants for cards
  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.2, duration: 0.7, ease: "easeOut" },
    }),
  };

  const { t } = useTranslation();
  const productKey = {
    "group-saving": "ikimina",
    "u-save": "uSave",
    crowdfund: "crowdfund",
  }[productName];

  return (
    <div
      id="benefits"
      className="min-h-screen bg-white dark:bg-defaultBlack pt-16 px-4 sm:px-6 lg:px-8 dark:text-white"
    >
      <div className="container mx-auto px-4 pt-12">
        {/* Header Section */}
        <div className="mb-12">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-6 capitalize">
            {t("singleProductPage.common.benefitsSection.title", {
              productName: product.name,
            })}
          </h1>
          <p className="text-lg text-gray-600 dark:text-white/70">
            {t(`singleProductPage.${productKey}.benefitsSection.title`)}
          </p>
        </div>

        {/* Main Content */}
        <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {product.benefits.content.map((benefit, i) => (
            <motion.div
              key={i}
              className="flex items-start space-x-4 p-6 bg-white dark:bg-white/5 shadow-md rounded-lg border border-defaultGray/10"
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              custom={i}
            >
              <CheckCircle2 className="w-6 h-6 text-defaultGreen/80 flex-shrink-0 mt-1" />

              <div>
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2 uppercase flex flex-wrap items-center">
                  {t(
                    `singleProductPage.${productKey}.benefitsSection.benefits.${i}.title`
                  )}
                </h3>
                <p className="text-gray-600 dark:text-white/70">
                  {t(
                    `singleProductPage.${productKey}.benefitsSection.benefits.${i}.description`
                  )}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
